import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleApiError, getResponse } from "../Handler/ExceptionHandler";
import { toast } from "react-toastify";
import { baseUrl } from "../../utils/envAccess";
import { message } from "antd";
import { keysToRemove } from "../../utils/constant";

//#region Login, Logout
export const postLogin = createAsyncThunk(
  "user/postLogin",
  async (userData, { rejectWithValue, getState, dispatch }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Auth/Login`,
        userData,
        config,
      );
   
      return response?.data;
    } catch (error) {
      handleApiError(error, dispatch);
    }
  },
);
export const getUserProfile = createAsyncThunk(
  "user/getProfile",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        accept: "text/plain",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.get(`${baseUrl}Profile/GetProfile`, config);

      // Use the response data directly
      const responseData = response.data;

      if (responseData) {
        return responseData;
      }

      return rejectWithValue("No response data");
    } catch (error) {
      return rejectWithValue(handleApiError(error, dispatch));
    }
  },
);

//`${baseUrl}Doctor/GetGeneralInformation/${id}`,
//async (id, { getState }) => {
export const getMiraInfoDoc = createAsyncThunk(
  "user/getMiraInfo",
  async (id , { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        accept: "text/plain",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Doctor/GetMiraInfo/${id}`,
        {},
        config,
      );

      const responseData = response.data;
      console.log(responseData, "responseData");

      if (responseData) {
        return responseData;
      }

      return rejectWithValue("No response data");
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Mira Info",
        dispatch,
      );
    }
  },
);

export const getMiraInfo = createAsyncThunk(
  "user/getMiraInfo",
  async (_, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        accept: "text/plain",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Patient/GetMiraInfo`,
        {},
        config,
      );

      const responseData = response.data;
      console.log(responseData, "responseData");

      if (responseData) {
        return responseData;
      }

      return rejectWithValue("No response data");
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Mira Info",
        dispatch,
      );
    }
  },
);

/**
 * Links logged in patient to their Mira account by the email
 * they use with the Mira app, then triggers a fresh sync on the backend.
 */
export const syncMira = createAsyncThunk(
  "user/syncMira",
  async (miraEmail, { rejectWithValue, getState }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        accept: "text/plain",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Patient/SyncMira`,
        { MiraEmail: miraEmail },
        config,
      );

      const responseData = response.data;

      if (!responseData) {
        return rejectWithValue("No response data");
      }

      const syncSucceeded =
        responseData?.success ??
        responseData?.Success ??
        responseData?.status ??
        responseData?.Status;

      if (syncSucceeded === false) {
        return rejectWithValue(responseData);
      }

      return responseData;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to sync Mira",
      );
    }
  },
);

/**
 * Patient opts in to Mira. Creates their Mira account, or maps an existing one.
 */
export const addMira = createAsyncThunk(
  "user/addMira",
  async (miraEmail, { rejectWithValue, getState }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        accept: "text/plain",
        Authorization: `Bearer ${user?.obj?.token}`,
      },
    };

    try {
      const response = await axios.patch(
        `${baseUrl}Profile/AddMira`,
        { MiraEmail: miraEmail },
        config,
      );

      const responseData = response.data;

      if (!responseData) {
        return rejectWithValue("No response data");
      }

      if ((responseData?.success ?? responseData?.Success) === false) {
        return rejectWithValue(responseData);
      }

      return responseData;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to connect Mira",
      );
    }
  },
);

export const postRegister = createAsyncThunk(
  "user/postRegister",
  
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${baseUrl}Auth/Register`, payload, {
        headers: { "Content-Type": "application/json" },
      });
      const responseBack = response?.data;
      // reads localStorage complete signup.
      if (responseBack) {
        localStorage.setItem("userInfo", JSON.stringify(responseBack));
      }
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch);
      return rejectWithValue(error?.response?.data ?? error?.message);
    }
  },
);

export const postCompleteSignUp = createAsyncThunk(
  "user/postCompleteSignUp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}Auth/CompleteSignUp`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Signup completion failed");
    }
  }
);

/** Looks up a quick-signup user by email to prefill CompleteSignup fields. Backend endpoint not yet implemented*/
export const getSignupPrefillByEmail = createAsyncThunk(
  "user/getSignupPrefillByEmail",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseUrl}Auth/GetSignupPrefillByEmail`, {
        params: { email },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Lookup failed");
    }
  }
);

/** Public quick signup (no auth) — JSON body uses PascalCase per API contract */
export const postUserQuickSignUp = createAsyncThunk(
  "user/postUserQuickSignUp",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${baseUrl}Auth/UserQuickSignUp`,
        {
          FirstName: body.FirstName,
          LastName: body.LastName,
          Email: body.Email,
          PhoneNumber: body.PhoneNumber,
          Gender: body.Gender,
          RefSource: body.RefSource ?? "",
          Location: body.Location,
        },
        {
          headers: {
            "Content-Type": "application/json",
            accept: "text/plain",
          },
        },
      );
      const d = response?.data;
      if (d?.status === false) {
        handleApiError(d, dispatch);
        return rejectWithValue(d);
      }
      // Do not use getResponse here: it treats missing `status` as error
      return d?.data ?? d;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch);
      return rejectWithValue(
        error?.response?.data ?? error?.message ?? "Request failed",
      );
    }
  },
);

export const validateEmail = createAsyncThunk(
  "user/validateEmail",
  async (email, { rejectWithValue }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Auth/ValidateEmail`,
        { value: email },
        config,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const validateEmailOtp = createAsyncThunk(
  "user/validateEmailOtp",
  async ({ email, session, code }, { rejectWithValue }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Auth/ValidateEmailOtp`,
        { email, session, code },
        config,
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const validateLoginOtp = createAsyncThunk(
  "user/validateLoginOtp",
  async ({ emailOrUsername, otp, validPeriod }, { rejectWithValue }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Auth/ValidateLoginOtp`,
        { emailOrUsername, otp, validPeriod },
        config,
      );
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const updateEmail = createAsyncThunk(
  "auth/updateEmail",
  async ({ email, session, newEmail }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}Auth/UpdateEmail`,
        { email, session, newEmail },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const sendEmailOtp = createAsyncThunk(
  "auth/sendEmailOtp",
  async ({ email, session }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}Auth/ResendEmailOtp`, {
        email,
        session,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);  
export const validateUsername = createAsyncThunk(
  "user/validateUsername",
  async (username, { rejectWithValue }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${baseUrl}Auth/ValidateUsername`,
        { value: username },
        config,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const logoutAction = createAsyncThunk(
  "/user/logout",
  async (payload, { rejectWithValue, getState }) => {
    const user = getState()?.auth?.userAuth;
    try {
      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
      });
      console.log("Logging out user:", user);
      return { success: true };
    } catch (error) {
      console.error("Logout error:", error);
      return rejectWithValue("Logout failed.");
    }
  },
);

const getUserFromLocalStorage = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

//#endregion

//#region Profile
export const getLoggedInUser = createAsyncThunk(
  "user/profile",
  async (id, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    try {
      const response = await axios.get(
        `${baseUrl}Auth/GetLoggedinUser?id=${id}`,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error, dispatch, user);
    }
  },
);

export const updateProfileImage = createAsyncThunk(
  "user/updateProfileImage",
  async (user, { rejectWithValue, getState, dispatch }) => {
    const users = getState()?.authentication?.userAuth;
    const formData = new FormData();
    formData.append("Id", user.Id);
    if (user.isDeleted) {
      formData.append("isDelete", 1);
    } else {
      formData.append("file", user.file);
    }
    const config = {
      headers: {
        Authorization: `Bearer ${users?.token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const response = await axios.put(
        `${baseUrl}Auth/UpdateProfilePicture`,
        formData,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      }
      return responseBack;
    } catch (error) {
      handleApiError(error, dispatch, user);
    }
  },
);

export const updateProfile = createAsyncThunk(
  "user/updateProfile",
  async (users, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Authorization: `Bearer ${user?.obj?.token}`,
        // Some endpoints require explicit accept header
        accept: "text/plain",
        // Ensure JSON payload content type for PATCH
        "Content-Type": "application/json",
      },
    };
    console.log({users})

    try {
      // Normalize gender key to 'gender' if provided in different forms
      const normalizedUsers = { ...users };
      if (users?.Gender && !normalizedUsers?.gender) normalizedUsers.gender = users.Gender;
      if (users?.sex && !normalizedUsers?.gender) normalizedUsers.gender = users.sex;

      const response = await axios.patch(
        `${baseUrl}Profile/PatchProfile`,
        normalizedUsers,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);

      if (response?.data?.status) {
        const currentUserInfo =
          JSON.parse(localStorage.getItem("userInfo")) || {};

        const updatedUserInfo = { ...currentUserInfo };
        Object.keys(responseBack).forEach((key) => {
          if (responseBack[key] !== currentUserInfo[key]) {
            updatedUserInfo[key] = responseBack[key];
          }
        });
        // Ensure gender is exposed under common keys for frontend consumption
        if (responseBack?.gender) {
          updatedUserInfo.gender = responseBack.gender;
        } else if (responseBack?.Gender) {
          updatedUserInfo.gender = responseBack.Gender;
        }
        
        // Also ensure the gender from the form submission is saved
        if (normalizedUsers?.gender) {
          updatedUserInfo.gender = normalizedUsers.gender;
        }

        localStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
        message.success(response?.data?.message);
      }
      return responseBack;
    } catch (error) {
      handleApiError(error, dispatch, user);
      return rejectWithValue(error);
    }
  },
);

//#endregion

//#region Password
export const updatePassword = createAsyncThunk(
  "user/updatePassword",
  async (user, { rejectWithValue, getState, dispatch }) => {
    //get user token
    const users = getState()?.authentication?.userAuth;
    const token = users?.obj?.token ?? users?.token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axios.put(
        `${baseUrl}Auth/UpdatePassword`,
        user,
        config,
      );

      getResponse(response, dispatch, users);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      }
      return response?.data;
    } catch (error) {
      handleApiError(error, dispatch, users);
      return rejectWithValue(error?.response?.data ?? error?.message);
    }
  },
);

export const forgotPassword = createAsyncThunk(
  "user/ForgotEmail",
  async (email, { rejectWithValue, getState, dispatch }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Auth/SendForgotPasswordLink`,
        email,
        config,
      );
      getResponse(response, dispatch);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      }
    } catch (error) {
      handleApiError(error, dispatch);
    }
  },
);

export const resetPassword = createAsyncThunk(
  "user/ResetPassword",
  async (data, { rejectWithValue, getState, dispatch }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("ResetPassword call api: ", data);
    try {
      const response = await axios.post(
        `${baseUrl}Auth/ResetPassword`,
        data,
        config,
      );
      const responseBack = getResponse(response, dispatch);
      if (response?.data?.status) {
        toast.success(response?.data?.message);
      }
      return responseBack;
    } catch (error) {
      handleApiError(error, dispatch);
      return rejectWithValue(error);
    }
  },
);

//#endregion

//#region Patient subscription
export const postSubscriptionPayment = createAsyncThunk(
  "user/postSubscriptionPayment",
  async (data, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Patient/SubscriptionPayment`,
        data,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (response?.data?.status) {
        console.log(
          "Subscription controller Update (postSubscriptionPayment) :" +
          responseBack,
        );
        toast.success(response?.data?.message);
      }
      return responseBack;
    } catch (error) {
      handleApiError(error, dispatch, user);
      rejectWithValue(error);
    }
  },
);

export const createCheckoutSession = createAsyncThunk(
  "user/createCheckoutSession",
  async (priceId, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.post(
        `${baseUrl}Patient/create-checkout-session?priceId=${priceId}`,
        null,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (response?.data?.status) {
        console.log(
          "create-checkout-session controller Update (postSubscriptionPayment) :" +
          responseBack,
        );
        toast.success(response?.data?.message);
      }
      return responseBack;
    } catch (error) {
      handleApiError(error, dispatch, user);
      // rejectWithValue(error);
    }
  },
);

export const getUpdatedSubscriptionDetail = createAsyncThunk(
  "user/getUpdatedSubscriptionDetail",
  async (userId, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.get(
        `${baseUrl}Patient/GetUpdatedSubscriptionDetail?UserId=${userId}`,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      if (response?.data?.status) {
        console.log(
          "Get Updated Subscription Detail auth call :",
          responseBack,
        );
        // toast.success(response?.data?.message);
      }
      return responseBack;
    } catch (error) {
      handleApiError(error, dispatch, user);
      rejectWithValue(error);
    }
  },
);

//#endregion

//#region Get Calendar Appointment
export const getAppointmentEvents = createAsyncThunk(
  "user/getAppointmentEvents",
  async (data, { rejectWithValue, getState, dispatch }) => {
    const user = getState()?.authentication?.userAuth;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user?.token}`,
      },
    };

    try {
      const response = await axios.get(
        `${baseUrl}Appointment/GetAppointmentCalendarEvents?StartDate=${data.startDate}&EndDate=${data.endDate}`,
        config,
      );
      const responseBack = getResponse(response, dispatch, user);
      return responseBack;
    } catch (error) {
      handleApiError(error?.response?.data, dispatch, user);
    }
  },
);
//#endregion

const authSlices = createSlice({
  name: "authentication",
  initialState: {
    // Must be serializable: call the helper, do not store the function reference.
    userAuth: getUserFromLocalStorage(),
    loading: false,
    appErr: null,
    appStatus: null,
    appStatusCode: null,
    serverErr: null,
  },
  reducers: {
    updateReduxUserAuth: (state, payload) => {
      state.userAuth = payload.payload;
    },
    setReduxUserAuthValuesUndefined: (state) => {
      state.userAuth = {}; // Setting userAuth to an empty object
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postLogin.pending, (state, action) => {
      state.appErr = undefined;
      state.loading = true;
      state.serverErr = undefined;
      state.appStatus = action.payload?.status || null;
      state.appStatusCode = action.payload?.statusCode || null;
    });
    builder.addCase(postLogin.fulfilled, (state, action) => {
      state.userAuth = action?.payload;
      state.appErr = undefined;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action.payload?.status || null;
      state.appStatusCode = action.payload?.statusCode || null;
    });
    builder.addCase(postLogin.rejected, (state, action) => {
      state.appErr = action.payload?.message || null;
      state.serverErr =
        action.error?.message || "An error occurred on the server.";
      state.appStatus = action.payload?.status || null;
      state.appStatusCode = action.payload?.statusCode || null;
      state.loading = false;
    });

    builder.addCase(postRegister.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.appStatus = undefined;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(postRegister.fulfilled, (state, action) => {
      state.loading = false;
      state.appErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(postRegister.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
      state.serverErr = undefined;
    });

    //Logout
    builder.addCase(logoutAction.pending, (state, action) => {
      state.loading = false;
    });
    builder.addCase(logoutAction.fulfilled, (state, action) => {
      state.userAuth = undefined;
      state.loading = false;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(logoutAction.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.serverErr = action?.error?.message;
      state.loading = false;
    });

    builder.addCase(updateProfileImage.pending, (state, action) => {
      state.profileLoading = true;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(updateProfileImage.fulfilled, (state, action) => {
      state.userAuth = action?.payload ? action.payload : state.userAuth; //action?.payload;
      state.profileLoading = false;
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(updateProfileImage.rejected, (state, action) => {
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.profileLoading = false;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(updateProfile.pending, (state, action) => {
      state.profileLoading = true;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.userAuth = action?.payload ? action.payload : state.userAuth;
      state.profileLoading = false;
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.profileLoading = false;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(postSubscriptionPayment.pending, (state, action) => {
      state.appErr = undefined;
      state.loading = true;
      state.serverErr = undefined;
      state.appStatus = action.payload?.status;
      state.appStatusCode = action.payload?.statusCode;
    });
    builder.addCase(postSubscriptionPayment.fulfilled, (state, action) => {
      state.userAuth = action?.payload ? action.payload : state.userAuth;
      state.appErr = undefined;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action.payload?.status;
      state.appStatusCode = action.payload?.statusCode;
    });
    builder.addCase(postSubscriptionPayment.rejected, (state, action) => {
      state.appErr = action.payload?.message;
      state.serverErr = action.error?.message;
      state.loading = false;
      state.appStatus = action.payload?.status;
      state.appStatusCode = action.payload?.statusCode;
    });

    builder.addCase(createCheckoutSession.pending, (state, action) => {
      state.userAuth.paymentTimeTicks = null;
      state.profileLoading = true;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(createCheckoutSession.fulfilled, (state, action) => {
      state.userAuth.paymentTimeTicks = action?.payload
        ? action.payload.paymentTimeTicks
        : null;
      state.profileLoading = false;
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(createCheckoutSession.rejected, (state, action) => {
      state.userAuth.paymentTimeTicks = null;
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.profileLoading = false;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(getUpdatedSubscriptionDetail.pending, (state, action) => {
      state.profileLoading = true;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(getUpdatedSubscriptionDetail.fulfilled, (state, action) => {
      state.userAuth.paymentFailure = action?.payload
        ? action?.payload.isSomethingFailure === true
          ? true
          : false
        : false;
      state.profileLoading = false;
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(getUpdatedSubscriptionDetail.rejected, (state, action) => {
      state.profileAppErr = action?.payload?.message;
      state.profileServerErr = action?.error?.message;
      state.profileLoading = false;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(getAppointmentEvents.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(getAppointmentEvents.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(getAppointmentEvents.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(updatePassword.pending, (state, action) => {
      state.loading = true;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
      state.appStatusCode = undefined;
    });
    builder.addCase(updatePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
      state.appStatus = false;
      state.appStatusCode = undefined;
    });

    builder.addCase(updatePassword.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    builder.addCase(resetPassword.pending, (state, action) => {
      state.loading = true;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.appStatus = false;
      state.appStatusCode = undefined;
      state.profileAppErr = undefined;
      state.profileServerErr = undefined;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });

    // Validate Login OTP cases
    builder.addCase(validateLoginOtp.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
    builder.addCase(validateLoginOtp.fulfilled, (state, action) => {
      state.userAuth = action?.payload ? action.payload : state.userAuth;
      state.appErr = undefined;
      state.loading = false;
      state.serverErr = undefined;
      state.appStatus = action.payload?.status;
      state.appStatusCode = action.payload?.statusCode;
    });
    builder.addCase(validateLoginOtp.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.loading = false;
      state.serverErr = action?.error?.message;
      state.appStatus = action?.payload?.status;
      state.appStatusCode = action?.payload?.statusCode;
    });
  },
});
export const { updateReduxUserAuth, setReduxUserAuthValuesUndefined } =
  authSlices.actions;
export default authSlices.reducer;
